import React from 'react';
import RadioList from 'components/UI/RadioList';
import FlexboxContainerComponent from 'components/UI/FlexboxContainer';
import {
  PricebookCategory,
  PRICEBOOK_CATEGORY_OPTIONS,
} from 'constants/pricebookCategories';
import styled from 'styled-components';

const Label = styled.span<any>`
  font-size: 16px;
  line-height: 20px;
  padding-bottom: 8px;
`;
interface Props {
  selectedCategory: PricebookCategory;
  onSelectCategory: (category: PricebookCategory) => void;
}

const PricebookCategorySelector = ({
  selectedCategory,
  onSelectCategory,
}: Props) => {
  return (
    <FlexboxContainerComponent flexDirection="column" width="100%" padding="24px 0px 32px 0px">
      <Label>Pricebook type</Label>
      <RadioList
        options={PRICEBOOK_CATEGORY_OPTIONS}
        selectedOption={selectedCategory}
        setSelectedOption={(value: string) => onSelectCategory(value as PricebookCategory)}
        variant="tile"
        direction="horizontal"
        gap="8px"
        compact
      />
    </FlexboxContainerComponent>
  );
};

export default PricebookCategorySelector;
